import { AutoMap } from "@automapper/classes";
import { TranslationDto } from "./translation.dto";

export class TranslationResponseDto {

    @AutoMap()
  public content!: TranslationDto[];

}